export default __webpack_public_path__ + "static/christmas-banner-mobile-e37ce05872cb954daf19517d082e00a7.png";